export default __webpack_public_path__ + "static/media/ig4.e5f68911.svg";